import React, { Component } from 'react';
import { Container, Row, Col, Button, Form, Alert, Spinner, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { connect } from 'react-redux';
import Switch from 'react-switch';
import { showFoundationDeletedNotification } from '../../redux/modules/notifications';
import './styles/styles.scss';

const select = state => {
  return {
    token: state.auth.token
  };
};

function mapDispatchToProps(dispatch) {
  return {
    showFoundationDeletedNotification: () => dispatch(showFoundationDeletedNotification())
  };
}

class ConnectedFoundationDetailComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loadingDenyValidation: false,
      removeFoundation: false,
      removeAvailable: false,
      removing: false,
      submitting: false,
      show: false,
      isLoading: true,
      validation: false,
      legalFilesValidation: false,
      bankAccountValidation: false,
      certificatesInfoToValidate: false,
      bankInfoToValidate: false,
      foundationNotFound: false,
      businessPlan: 'NONE',
      data: {
        name: { value: '' },
        phone: { value: '' },
        email: { value: '' },
        logo: { value: '' },
        description: { label: 'Descripción', value: '', changed: false, type: 'textarea', cols: 12 },
        mission: { label: 'Misión', value: '', changed: false, type: 'textarea', cols: 12 },
        vision: { label: 'Visión', value: '', changed: false, type: 'textarea', cols: 12 },
        website: { label: 'Página Web', value: '', changed: false },
        address: { label: 'Dirección', value: '', changed: false },
        yearFounded: { label: 'Fundada en', value: '', changed: false },
        instagram: { label: 'Instagram', value: '', changed: false, cols: 4 },
        facebook: { label: 'Facebook', value: '', changed: false, cols: 4 },
        twitter: { label: 'Twitter', value: '', changed: false, cols: 4 },
        contactName: { label: 'Nombre del contacto', value: '', changed: false, cols: 3 },
        contactEmail: { label: 'Email de contacto', value: '', changed: false, cols: 3 },
        contactPhone: { label: 'Teléfono de contacto', value: '', changed: false, cols: 3 },
        contactAddress: { label: 'Dirección de contacto', value: '', changed: false, cols: 3 },
        bankAccountNumber: { label: 'Número de cuenta bancaria', value: '', changed: false },
        bankAccountType: { label: 'Tipo de cuenta bancaria', value: '', changed: false },
        bankName: { label: 'Nombre del banco', value: '', changed: false },
        legallyConstituted: { label: 'Legalmente constituida', value: false, changed: false },
        location: { label: 'Lugar de operación', value: '', changed: false },
        mainOds: { value: '' },
        secondaryOds: { value: '' },
        foundationType: { value: '' },
        category: { value: '' },
        additionalContacts: { value: '' },
        values: { value: '' },
        locations: { value: '' },
        resourcesNeeded: { value: '' },
        nit: { label: 'NIT', value: '', changed: false },
        representativeName: { label: 'Nombre de la persona que firma', value: '', changed: false },
        jobTitle: { label: 'Cargo de la persona que firma', value: '', changed: false },
        certificateLocation: { label: 'Ciudad donde se expide el certificado', value: '', changed: false },
        // Files
        bankAccountCertificate: { cols: 6, fileType: 'application/pdf', file: '', label: 'Certificado de cuenta bancaria (PDF)', value: '', changed: false },
        representativeIdentification: { cols: 6, fileType: 'application/pdf', file: '', label: 'Copia de la cédula del representante legal (PDF)', value: '', changed: false },
        rut: { cols: 6, fileType: 'application/pdf', file: '', label: 'RUT de la fundación (PDF)', value: '', changed: false },
        camaraComercio: { cols: 6, fileType: 'application/pdf', file: '', label: 'Cámara de comercio fundación (PDF)', value: '', changed: false },
        representativeSign: { cols: 6, fileType: 'image/*', file: '', label: 'Imagen firma digital (tamaño recomendado: 250 x 100)', value: '', changed: false }
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderInputFields = this.renderInputFields.bind(this);
    this.renderFileInputs = this.renderFileInputs.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.removeFoundation = this.removeFoundation.bind(this);
    this.removeInputChange = this.removeInputChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.denyValidation = this.denyValidation.bind(this);
  }

  async denyValidation() {
    const { id, token, history } = this.props;
    this.setState({ loadingDenyValidation: true });

    const promise = await fetch(`${apiUrl}/admin/enterprises_foundations/deny_validation?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        type: 'FOUNDATION',
        id
      })
    });

    const removeResp = await promise.json();

    if (removeResp.success) history.push('/fundaciones');

  }

  removeFoundation() {
    this.setState({ removeFoundation: true });
  }

  removeInputChange(event) {
    this.setState({ removeAvailable: event.target.value === 'ELIMINAR' });
  }

  async handleRemove() {
    const { id, token, history } = this.props;
    this.setState({ removing: true });

    const removeResponse = await fetch(`${apiUrl}/admin/foundations/remove_foundation?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        foundationRemoveId: id
      })
    });

    const removeResp = await removeResponse.json();

    if (removeResp.success) {
      await this.props.showFoundationDeletedNotification();
      history.push('/fundaciones');
    }
  }

  handleSwitchChange(checked, name) {
    this.setState({ [name]: checked });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleInputChange(event) {
    const { data } = this.state;

    const updatedData = { 
      ...data, [event.target.name]: { 
        ...data[event.target.name],
        value: event.target.value,
        changed: true
      }
    };

    this.setState({ data: updatedData });
  }

  async componentDidMount() {

    const { id, token } = this.props;

    const foundationResp = await fetch(`${apiUrl}/admin/foundation/${id}?token=${token}`);
    const foundationData = await foundationResp.json();
    
    if (foundationData.success) {

      const { data } = this.state;
      const { foundation } = foundationData;

      const newData = {};

      Object.keys(data).forEach(key => {
        const original = data[key];
        const newObj = {...original, value: foundation[key]};

        newData[key] = newObj;
      });

      this.setState({
        data: newData,
        validation: foundation.validation === '2',
        legalFilesValidation: foundation.legalFilesValidation,
        certificatesInfoToValidate: foundation.certificatesInfoToValidate,
        bankAccountValidation: foundation.bankAccountValidation,
        bankInfoToValidate: foundation.bankInfoToValidate,
        businessPlan: foundation.businessPlan || 'NONE'
      });
    } else {
      this.setState({ foundationNotFound: true });
    }

    this.setState({ isLoading: false });
  }

  renderInputFields(fields) {

    const { data } = this.state;

    const inputs = Object.keys(fields).map(key => {

      const {
        label,
        value,
        type,
        cols
      } = data[key];

      return (
        <Form.Group key={key} as={Col} md={cols ? cols : 4}>
          <Form.Label><strong>{label}:</strong></Form.Label>
          <Form.Control
            type="text"
            onChange={this.handleInputChange}
            value={value}
            name={key}
            placeholder={label}
            as={type === 'textarea' ? 'textarea' : 'input'}
            rows={type === 'textarea' ? '3' : '1'}
          />
          <Form.Control.Feedback type="invalid">
            Valor inválido.
          </Form.Control.Feedback>
        </Form.Group>
      );
    });

    return inputs;
  }

  handleFileChange(event) {
    if (event.target.files[0]) {

      const { data } = this.state;

      const updatedData = {
        ...data,
        [event.target.name]: {
          ...data[event.target.name],
          file: event.target.files,
          value: event.target.files[0].name,
          changed: true
        }
      };

      this.setState({ data: updatedData });
      
    }
  }

  triggerInputFile(input) {
    this[input].click();
  }

  renderFileInputs(files) {

    const { data } = this.state;
    
    const inputs = Object.keys(files).map(key => {

      const {
        label,
        value,
        fileType,
        file,
        cols,
        changed
      } = data[key];

      let fileNameArr, fileName, displayedName;

      if (value) {
        fileNameArr = value.split('com/');
        fileName = fileNameArr.length > 1 ? fileNameArr[1] : fileNameArr[0];
        displayedName = fileName.length > 25 ? `${fileName.substring(0, 25)}...` : fileName;
      }

      return (
        <Form.Group key={key} as={Col} md={cols ? cols : 4}>
          <Form.Label><strong>{label}:</strong></Form.Label>
          <Form.Control
            type="file"
            ref={fileInput => this[key] = fileInput}
            name={key}
            files={file}
            onChange={this.handleFileChange}
            accept={fileType}
            hidden
          />
          <div className="form-custom-file-input">
            <Button onClick={() => this.triggerInputFile(key)}>
              Selecciona un archivo
            </Button>
            <span style={{marginLeft: '5px'}}>
              {
                value ? 
                (changed ? displayedName :
                <a href={value} target="_blank" rel="noopener noreferrer">{displayedName}</a>) :
                'No hay archivos seleccionados'
              }
            </span>
          </div>
        </Form.Group>
      );

    });

    return inputs;
    
  }

  readFile(file) {
    const reader = new FileReader();
    reader.addEventListener('load', undefined);

    reader.readAsDataURL(file);

    const formData = new FormData();
    formData.append('file', file);

    return formData;
  }

  async uploadFile(fileInput) {

    let fileUrl;

    if (fileInput) {

      const formData = this.readFile(fileInput[0]);

      const uploadFile = await fetch(`${apiUrl}/files/file-upload`, {
        method: 'POST',
        body: formData
      });

      const fileJson = await uploadFile.json();
      fileUrl = fileJson.fileUrl;
    }

    return fileUrl;
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ submitting: true });

    const {
      data,
      validation,
      legalFilesValidation,
      bankAccountValidation,
      bankInfoToValidate,
      certificatesInfoToValidate,
      businessPlan
    } = this.state;
    const { token, id } = this.props;
    const updatedData = {};
    const promises = [];

    Object.keys(data).forEach(async key => {

      const obj = {...data[key]};

      if (obj.changed) {

        if (obj.file) {
          const filePromise = this.uploadFile(obj.file);

          promises.push(filePromise);
          obj.value = await filePromise;
        } 
        
        updatedData[key] = obj.value;

      }

    });

    await Promise.all(promises);

    updatedData.validation = validation ? '2' : '1';
    updatedData.legalFilesValidation = legalFilesValidation;
    updatedData.bankAccountValidation = bankAccountValidation;

    if (certificatesInfoToValidate && legalFilesValidation) updatedData.certificatesInfoToValidate = false;
    if (bankInfoToValidate && bankAccountValidation) updatedData.bankInfoToValidate = false;
    
    const updateFoundation = await fetch(`${apiUrl}/admin/foundations/update?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id,
        update: updatedData,
        businessPlan
      })
    });

    const updateFoundationJson = await updateFoundation.json();

    if (updateFoundationJson.success) this.setState({ show: true });

    this.setState({ submitting: false });

  }

  render() {

    const {
      isLoading,
      data,
      validation,
      legalFilesValidation,
      bankAccountValidation,
      submitting,
      show,
      foundationNotFound,
      businessPlan,
      removeFoundation,
      removing,
      removeAvailable,
      loadingDenyValidation
    } = this.state;

    if (isLoading) return (<AppSpinner />);
    if (foundationNotFound) return (<h1 className="not-found-error">La fundación especificada no existe.</h1>);

    const {
      name,
      phone,
      email,
      logo,
      contactName,
      contactEmail,
      contactPhone,
      contactAddress,
      facebook,
      instagram,
      twitter,
      mainOds,
      secondaryOds,
      category,
      additionalContacts,
      values,
      locations,
      resourcesNeeded,
      nit,
      bankAccountNumber,
      bankAccountType,
      bankName,
      representativeName,
      jobTitle,
      certificateLocation,
      bankAccountCertificate,
      representativeIdentification,
      rut,
      camaraComercio,
      representativeSign,
      foundationType,
      ...fields
    } = data;

    const contacts = {contactName, contactEmail, contactPhone, contactAddress};
    const socialMedia = {facebook, instagram, twitter};
    const bankInfo = {bankAccountNumber, bankAccountType, bankName};
    const legalInfo = {nit, representativeName, jobTitle, certificateLocation};
    const bankAccountFiles = {bankAccountCertificate, representativeIdentification};
    const legalFiles = {rut, camaraComercio, representativeSign};

    return (
      <div className="detail-info-component foundation-detail-component">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="user-detail-options">
                <Link to="/fundaciones">
                  <Button variant="secondary">
                    Atrás
                  </Button>
                </Link>
                <Button variant="danger" onClick={this.removeFoundation}>
                  Eliminar fundación
                </Button>
              </div>
            </Col>
            <Col xs={12}>
              <div style={{ display: 'flex' }}>
                <img src={logo.value} alt="" />
                <div className="header-info">
                  <h2>{name.value}</h2>
                  <h5><strong>Correo: </strong> {email.value}</h5>
                  <h5><strong>Teléfono: </strong>{phone.value}</h5>
                </div>
              </div>
              <hr />
            </Col>
            <Col xs={12}>

              <Form onSubmit={this.handleSubmit}>
                <Form.Row>
                  {this.renderInputFields(fields)}
                </Form.Row>

                <Form.Row>
                  {
                    values.value &&
                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Valores:</strong></Form.Label>
                      {
                        <Form.Control
                          type="text"
                          defaultValue={values.value.map(value =>
                            value.label
                          ).join(', ')}
                          disabled
                        />
                      }
                    </Form.Group>
                  }
                  
                  {
                    resourcesNeeded.value &&
                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Recursos buscados:</strong></Form.Label>
                      {
                        <Form.Control
                          type="text"
                          defaultValue={resourcesNeeded.value.map(resource =>
                            resource.label
                          ).join(', ')}
                          disabled
                        />
                      }
                    </Form.Group>
                  }                  

                  {
                    locations.value &&
                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Sedes:</strong></Form.Label>
                      {
                        <Form.Control
                          type="text"
                          defaultValue={locations.value.map(location =>
                            location.label
                          ).join(', ')}
                          disabled
                        />
                      }
                    </Form.Group>
                  }

                </Form.Row>
                <hr />

                <h4>Categorización:</h4>
                
                <Form.Row>
                  {
                    category.value &&
                    <Form.Group as={Col} md={3}>
                      <Form.Label><strong>Categoría:</strong></Form.Label>
                      {
                        <Form.Control
                          type="text"
                          defaultValue={category.value.map(category => 
                            category.label
                          ).join(', ')}
                          disabled
                        />
                      }
                    </Form.Group>
                  }
                  
                  <Form.Group as={Col} md={3}>
                    <Form.Label><strong>ODS:</strong></Form.Label>
                    {
                      <Form.Control
                        type="text"
                        defaultValue={mainOds.value.map(ods => 
                          ods.label
                        ).join(', ')}
                        disabled
                      />
                    }
                  </Form.Group>

                  <Form.Group as={Col} md={3}>
                    <Form.Label><strong>ODS secundarios:</strong></Form.Label>
                    {
                      <Form.Control
                        type="text"
                        defaultValue={secondaryOds.value.map(ods => 
                          ods.label
                        ).join(', ')}
                        disabled
                      />
                    }
                  </Form.Group>

                  <Form.Group as={Col} md={3}>
                    <Form.Label><strong>Tipo:</strong></Form.Label>
                    {
                      <Form.Control
                        type="text"
                        defaultValue={foundationType.value}
                        disabled
                      />
                    }
                  </Form.Group>

                </Form.Row>
                <hr />

                <h4>Redes:</h4>
                <Form.Row>
                  {this.renderInputFields(socialMedia)}
                </Form.Row>
                <hr />

                <h4>Contactos:</h4>

                <Form.Row>
                  {this.renderInputFields(contacts)}
                </Form.Row>

                {
                  additionalContacts.value.map(contact =>
                    <Form.Row key={contact.name}>
                      <Form.Group as={Col} md={3}>
                        <Form.Label><strong>Nombre:</strong></Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={contact.name}
                          disabled
                        />
                      </Form.Group>

                      <Form.Group as={Col} md={3}>
                        <Form.Label><strong>Teléfono:</strong></Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={contact.phone}
                          disabled
                        />
                      </Form.Group>

                      <Form.Group as={Col} md={3}>
                        <Form.Label><strong>Email:</strong></Form.Label>
                        <Form.Control
                          type="text"
                          defaultValue={contact.email}
                          disabled
                        />
                      </Form.Group>
                    </Form.Row>
                  )
                }
                <hr />

                <h4>Cuenta bancaria:</h4>

                <Form.Row>
                  {this.renderInputFields(bankInfo)}
                </Form.Row>

                <Form.Row>
                  {this.renderFileInputs(bankAccountFiles)}
                </Form.Row>
                <hr />

                <h4>Información para certificados de donación:</h4>

                <Form.Row>
                  {this.renderInputFields(legalInfo)}
                </Form.Row>

                <Form.Row>
                  {this.renderFileInputs(legalFiles)}
                </Form.Row>
                <hr />

                <Form.Row>
                  <Form.Group as={Col} xs={4}>
                    <Form.Label><strong>Plan:</strong></Form.Label>
                    <Form.Control
                      as="select"
                      name="businessPlan"
                      value={businessPlan}
                      onChange={event => this.setState({ businessPlan: event.target.value })}
                    >
                      <option value="NONE">Ninguno</option>
                      <option value="PREMIUM">Premium</option>
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                <hr />

                {
                  !validation &&
                  <Button variant="danger" style={{ marginBottom: '20px' }} onClick={this.denyValidation}>
                    {
                      loadingDenyValidation ?
                      <Spinner animation="border" variant="warning" size="sm" /> :
                      'Rechazar fundación'
                    }
                  </Button>
                }

                <Alert variant="info">
                  <h4>Validación:</h4>
                  <Row>
                    <Col className="switch-col" lg={4}>
                      <div className="switch-input">
                        <span>Validar fundación</span>
                        <Switch
                          onChange={checked => this.handleSwitchChange(checked, 'validation')}
                          checked={validation}
                        />
                      </div>
                    </Col>
                    <Col className="switch-col" lg={4}>
                      <div className="switch-input">
                        <span>Validar información de certificados</span>
                        <Switch
                          onChange={checked => this.handleSwitchChange(checked, 'legalFilesValidation')}
                          checked={legalFilesValidation}
                        />
                      </div>
                    </Col>
                    <Col className="switch-col" lg={4}>
                      <div className="switch-input">
                        <span>Validar información bancaria</span>
                        <Switch
                          onChange={checked => this.handleSwitchChange(checked, 'bankAccountValidation')}
                          checked={bankAccountValidation}
                        />
                      </div>
                    </Col>
                  </Row>
                </Alert>

                <div className="form-buttons">

                  <Link to="/fundaciones">
                    <Button variant="secondary">
                      Atrás
                    </Button>
                  </Link>

                  <Button type="submit" className="nibi-btn">
                    {
                      submitting ? <Spinner animation="border" variant="warning" size="sm" /> : 'Guardar cambios'
                    }
                  </Button>
                </div>

              </Form>

            </Col>
          </Row>
        </Container>

        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Cambios guardados</Modal.Title>
          </Modal.Header>
          <Modal.Body>Se han guardado los cambios</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose}>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={removeFoundation} onHide={() => this.setState({ removeFoundation: false, removing: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar fundación</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              validation ?
              <Alert variant="warning">
                No puedes eliminar una fundación que ya fue validada.
              </Alert> :
              removing ? <AppSpinner /> :
              <>
                <Alert variant="danger">
                  Esta acción no se puede deshacer.
                  La fundación será eliminada permanentemente.
                </Alert> 
                
                <Form.Row>
                  <Form.Group as={Col} xs={12}>
                    <p>
                      Por favor excriba ELIMINAR para confirmar.
                    </p>
                    <Form.Control
                      type="text"
                      onChange={this.removeInputChange}
                    />
                  </Form.Group>
                  <Col className="modal-btn-col" xs={12}>
                    <Button variant="secondary" onClick={() => this.setState({ removeFoundation: false, removing: false })}>
                      Cancelar
                    </Button>
                    <Button variant="danger" disabled={!removeAvailable} onClick={this.handleRemove}>
                      Eliminar
                    </Button>
                  </Col>
                </Form.Row>
              </>
            }
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

const FoundationDetailComponent = connect(select, mapDispatchToProps)(ConnectedFoundationDetailComponent);

export default FoundationDetailComponent;
